import { Controller } from "stimulus"
import GLightbox from "glightbox"
import "glightbox/dist/css/glightbox.min.css"

export default class extends Controller {
  connect() {
    // Generate unique ID for this controller instance
    const uniqueId = `glightbox-${Math.random().toString(36).substr(2, 9)}`

    // Add unique class to all links in this controller
    this.element.querySelectorAll('.glightbox').forEach(el => {
      el.classList.add(uniqueId)
    })

    // Initialize GLightbox with the unique selectors
    this.lightbox = GLightbox({
      selector: `.${uniqueId}`,
      touchNavigation: true,
      loop: true,
      zoomable: true,
      draggable: true,
      dragToleranceX: 40,
      dragToleranceY: 65,
      preload: true,
      openEffect: 'zoom',
      closeEffect: 'zoom',
      keyboardNavigation: true,
      closeOnOutsideClick: true
    })

    this.uniqueId = uniqueId
  }

  disconnect() {
    if (this.lightbox) {
      this.lightbox.destroy()
    }
    // Clean up unique class
    if (this.uniqueId) {
      this.element.querySelectorAll(`.${this.uniqueId}`).forEach(el => {
        el.classList.remove(this.uniqueId)
      })
    }
  }
}
